import {renderField} from "./utils";

export type IdParams = {
  values: string
  boost?: number
}

export type TermParams = {
  property: string
  value: string
  boost?: number
};

export type RangeParams = {
  property: string
  gte: string
  lte: string
};

export const ids = (params: IdParams): string => {
  return `
    {
      ids: {
        values: [${params.values}]
        ${renderField('boost', params.boost)}
      } 
    }`;
};


export const term = (params: TermParams): string => {
  return `
    {
      term: {
        ${params.property}: {
          value: ${params.value}
          ${renderField('boost', params.boost)}
        }
      }
    }
  `;
};

export const range = (params: RangeParams): string => {
  return `
    {
      range: {
        ${params.property}: {
          gte: ${params.gte}
          lte: ${params.lte}
        }
      }
    }
  `;
};
